import { useEffect, useRef } from "react";

const TICK_MS = 500;
const FLUSH_MS = 10000;

// Accumulates seconds each [data-sec] section is ≥ 50 % visible and beacons the totals to `url` (text/plain JSON — works with sendBeacon).
export function useSectionDwell(url, ready, extra = {}) {
  const acc = useRef({}); const visible = useRef(new Set()); const scroll = useRef(0); const pdf = useRef(false); const sid = useRef(null);
  const extraRef = useRef(extra); extraRef.current = extra;
  useEffect(() => {
    if (!ready || !url) return undefined;
    const key = `qs-dwell-${url}`;
    sid.current = sessionStorage.getItem(key) || (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    sessionStorage.setItem(key, sid.current);
    const els = Array.from(document.querySelectorAll("[data-sec]"));
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { const k = e.target.getAttribute("data-sec"); const vh = window.innerHeight || 1; const seen = e.intersectionRatio >= 0.5 || e.intersectionRect.height >= vh * 0.5; if (e.isIntersecting && seen) visible.current.add(k); else visible.current.delete(k); }), { threshold: [0, 0.25, 0.5, 0.75, 1] });
    els.forEach((el) => io.observe(el));
    const tick = setInterval(() => { if (document.visibilityState !== "visible") return; visible.current.forEach((k) => { acc.current[k] = (acc.current[k] || 0) + TICK_MS / 1000; }); const h = document.documentElement; const pct = Math.round(((window.scrollY + window.innerHeight) / Math.max(h.scrollHeight, 1)) * 100); if (pct > scroll.current) scroll.current = Math.min(pct, 100); }, TICK_MS);
    const flush = () => {
      const sections = acc.current; const any = Object.values(sections).some((v) => v > 0);
      if (!any && !pdf.current) return;
      const body = JSON.stringify({ session_id: sid.current, sections, max_scroll_pct: scroll.current, pdf_click: pdf.current, ...extraRef.current });
      acc.current = {}; pdf.current = false;
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
      else fetch(url, { method: "POST", body, headers: { "Content-Type": "text/plain" }, keepalive: true }).catch(() => {});
    };
    const iv = setInterval(flush, FLUSH_MS);
    const onHide = () => { if (document.visibilityState === "hidden") flush(); };
    document.addEventListener("visibilitychange", onHide); window.addEventListener("pagehide", flush);
    return () => { clearInterval(tick); clearInterval(iv); io.disconnect(); document.removeEventListener("visibilitychange", onHide); window.removeEventListener("pagehide", flush); flush(); };
  }, [url, ready]);
  return { markPdf: () => { pdf.current = true; } };
}
